export const REQUEST_SITE_OPTIONS = 'REQUEST_SITE_OPTIONS';
export const RECEIVE_SITE_OPTIONS = 'RECEIVE_SITE_OPTIONS';
export const REQUEST_CONTENT_ITEM = 'REQUEST_CONTENT_ITEM';
export const REQUEST_ARCHIVE = 'REQUEST_ARCHIVE';
export const REQUEST_NEXT_PAGE = 'REQUEST_NEXT_PAGE';
export const REQUEST_NEXT_PAGE_FETCH_INITIATED = 'REQUEST_NEXT_PAGE_FETCH_INITIATED';
export const REQUEST_SEARCH = 'REQUEST_SEARCH';
export const RECEIVE_SECONDARY_CONTENT = 'RECEIVE_SECONDARY_CONTENT';
export const RECEIVE_PRIMARY_CONTENT = 'RECEIVE_PRIMARY_CONTENT';
export const RECEIVE_ERROR = 'RECEIVE_ERROR';
export const REQUEST_LATEST = 'REQUEST_LATEST';
export const REQUEST_LATEST_NEXT_PAGE = 'REQUEST_LATEST_NEXT_PAGE';
export const QUERY_AB_TESTER = 'QUERY_AB_TESTER';
export const AUTHENTICATE_USER_REQUESTED = 'AUTHENTICATE_USER_REQUESTED';
export const AUTHENTICATE_USER_SUCCEEDED = 'AUTHENTICATE_USER_SUCCEEDED';
export const AUTHENTICATE_USER_ERRORED = 'AUTHENTICATE_USER_ERRORED';
export const FETCH_USER_REQUESTED = 'FETCH_USER_REQUESTED';
export const FETCH_USER_SUCCEEDED = 'FETCH_USER_SUCCEEDED';
export const FETCH_USER_ERRORED = 'FETCH_USER_ERRORED';
export const ARTICLE_LINK_CLICKED = 'ARTICLE_LINK_CLICKED';
export const ARTICLE_SHARED = 'ARTICLE_SHARED';
export const ARTICLE_VIDEO_STARTED = 'ARTICLE_VIDEO_STARTED';

export default {
  REQUEST_SITE_OPTIONS,
  RECEIVE_SITE_OPTIONS,
  REQUEST_CONTENT_ITEM,
  REQUEST_ARCHIVE,
  REQUEST_NEXT_PAGE,
  REQUEST_NEXT_PAGE_FETCH_INITIATED,
  REQUEST_SEARCH,
  RECEIVE_SECONDARY_CONTENT,
  RECEIVE_PRIMARY_CONTENT,
  RECEIVE_ERROR,
  REQUEST_LATEST,
  REQUEST_LATEST_NEXT_PAGE,
  QUERY_AB_TESTER,
  AUTHENTICATE_USER_REQUESTED,
  AUTHENTICATE_USER_SUCCEEDED,
  AUTHENTICATE_USER_ERRORED,
  FETCH_USER_REQUESTED,
  FETCH_USER_SUCCEEDED,
  FETCH_USER_ERRORED,
  ARTICLE_LINK_CLICKED,
  ARTICLE_SHARED,
  ARTICLE_VIDEO_STARTED,
};
